import { render, staticRenderFns } from "./elements-preview.vue?vue&type=template&id=65e746ba&scoped=true&"
import script from "./elements-preview.vue?vue&type=script&lang=js&"
export * from "./elements-preview.vue?vue&type=script&lang=js&"
import style0 from "./elements-preview.vue?vue&type=style&index=0&id=65e746ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e746ba",
  null
  
)

export default component.exports